(function () {
  let debounceTimer = null;

  document.addEventListener('change', function (event) {
    const input = event.target;

    // Solo nos interesan radio inputs dentro del modal
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;

    const dialog = input.closest('quick-add-dialog');
    if (!dialog) return;

    // Comprobamos cuántas opciones tiene el producto
    const variantPicker = dialog.querySelector('variant-picker');
    if (!variantPicker) return;

    const optionGroups = variantPicker.querySelectorAll('fieldset');

    // Solo auto-submit si hay UNA sola opción
    if (optionGroups.length !== 1) return;

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      const submitButton = dialog.querySelector(
        'product-form-component [type="submit"], product-form-component .add-to-cart__button button'
      );
      if (submitButton && !submitButton.disabled) {
        submitButton.click();
      }
    }, 300);
  });
})();
